import { FC, useEffect, useState } from "react";
import { useTitle } from "hooks";
import { HomeImages } from "design-system/images/home";
import { ContainerFull } from "./styled";

const Maintenance: FC = () => {
	useTitle("Manutenção");
	return (
		<>
			<ContainerFull>
				<h1>Estamos melhorando o Agrega!</h1>
				<h2>
					O site estará em manutenção <strong>até o dia 17/09/2023.</strong>
				</h2>
				<h2>Manteremos você informado. Aguarde as novidades.</h2>
				<img src={HomeImages.Maintenance} alt="" />
			</ContainerFull>
		</>
	);
};

export default Maintenance;
